module.exports = __webpack_public_path__ + "img/invoiceTip1.030c466d.png";